import { render, staticRenderFns } from "./ArtistTestimonials.vue?vue&type=template&id=a3a34428&scoped=true"
import script from "./ArtistTestimonials.vue?vue&type=script&lang=js"
export * from "./ArtistTestimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a34428",
  null
  
)

export default component.exports